<template>
    <img :src="`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`" class="blur-up lazyload" :width="width" :height="height" data-sizes="auto"
         :data-srcset="imageXlSrc + ' ' + imageXlWidth + 'w, ' + imageMdSrc + ' ' + imageMdWidth + 'w'"/>
</template>

<script>
    import lazysizesPolyfill from 'lazysizes/plugins/respimg/ls.respimg.js' //polyfill for srcset attribute of img-elements
    import lazysizes from 'lazysizes' //lazy load images: https://github.com/aFarkas/lazysizes

    export default {
        props: [
            'width',
            'height',
            'imageXlSrc',
            'imageMdSrc',
            'imageXlWidth',
            'imageMdWidth'
        ],
        data() {
            return {};
        },
        mounted() {

        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/css">
    .blur-up {
        opacity: 0;
        transition: opacity 300ms;

        &.lazyloaded {
            opacity: 1;
        }
    }

</style>
